import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { FONTS, COLORS, device } from '../../../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  index: number;
  length: number;
}

export const Counter: React.FC<DivProps> = ({ index, length, ...props }) => {
  return (
    <ElementStyle {...props}>
      <TextWrapper>
        <Text
          text={`${index}`}
          size={60}
          lineHeight={70}
          color={COLORS.MAIN_RED}
          fontFamily={FONTS.TITLE}
        />
      </TextWrapper>
      <TextSubWrapper>
        <Text
          text={`/${length}`}
          size={36}
          lineHeight={46}
          color={COLORS.MAIN_RED}
          fontFamily={FONTS.TITLE}
          opacity={0.5}
        />
      </TextSubWrapper>
    </ElementStyle>
  );
};

const ElementStyle = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
`;

const TextWrapper = styled.div`
  height: 70px;
  display: flex;
  align-items: flex-end;
  @media screen and ${device.md} {
    h4 {
      font-size: 30px;
      line-height: 40px;
    }
    height: auto;
  }
`;
const TextSubWrapper = styled.div`
  height: 70px;
  display: flex;
  align-items: flex-end;
  @media screen and ${device.md} {
    height: auto;
    h4 {
      font-size: 20px;
      line-height: 28px;
    }
  }
`;
